export const setCalendarList = (state, payload) => state.calendarList = payload;
export const concatCalendarList = (state, payload) => state.calendarList = state.calendarList.concat(payload);
export const changeProposalToTodo = (state, id) => {
  const proposal = state.calendarList.find(proposal => proposal.id === id);
  Object.assign(proposal, {is_todo: true})
};
export const setNeedShowProposalModal = (state, boolean) => state.needShowProposalModal = boolean;
export const setCurrentCalendarOptions = (state, payload) => state.currentCalendarOptions = payload;
export const updateCurrentCalendarOptions = (state, payload) => state.currentCalendarOptions = {
  ...state.currentCalendarOptions,
  ...payload
};
export const setShowCalendarDragModal = (state, payload) => state.showCalendarDragModal = payload;
export const setDragCalendarState = (state, payload) => state.dragCalendarState = payload;

export const setMstProcessingEvents = (state, payload) => state.mstProcessingEvents = payload;
export const pushMstProcessingEvent = (state, payload) => state.mstProcessingEvents.push(payload);
export const removeMstProcessingEventById = (state, id) => {
  if (Array.isArray(id)) {
    return state.mstProcessingEvents = state.mstProcessingEvents
      .filter(mstProposal => !id.includes(mstProposal.id))
  }

  return state.mstProcessingEvents = state.mstProcessingEvents
    .filter(proposal => proposal.id != id)
};
